import { useTranslation } from 'react-i18next';

import { EmptyStateIllustration } from '@/components/icons/EmptyStateIllustration';
import { Navigation } from '@/components/Navigation';

export function MessagesPage() {
  const { t } = useTranslation('providers');

  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main className="container mx-auto px-4 py-6">
        <h1 className="text-2xl font-bold">{t('pages.messages.title')}</h1>
        <p className="text-sm text-muted-foreground mt-1">{t('pages.messages.subtitle')}</p>
        <div className="mt-10 flex flex-col items-center justify-center border-2 border-dashed border-border rounded-xl py-16 gap-4">
          <EmptyStateIllustration className="w-48 opacity-40" />
          <p className="text-muted-foreground text-sm">{t('pages.messages.empty')}</p>
        </div>
      </main>
    </div>
  );
}
